import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import React from 'react';
import { MdOutlineErrorOutline } from 'react-icons/md';
import { useComponentStrings } from '../ComponentStringsProvider/ComponentStringsProvider.js';
export function ErrorDisplay({ className, header, error, actions, }) {
    const componentStrings = useComponentStrings();
    return (_jsx("div", { className: clsx('flex h-full items-center justify-center', className), children: _jsxs("div", { className: "flex max-w-xl flex-col items-center space-y-4 text-center", children: [_jsx("div", { children: _jsx(MdOutlineErrorOutline, { className: "h-20 w-20 text-foreground-300 dark:text-foreground-700" }) }), _jsx("h1", { children: header ?? componentStrings.genericErrorHeader }), _jsx("p", { className: "text-base", children: typeof error === 'string' || React.isValidElement(error)
                        ? error
                        : componentStrings.genericErrorContent }), actions] }) }));
}
